var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-select",
    {
      ref: "catalogSelection",
      staticStyle: { width: "144px" },
      attrs: {
        size: "small",
        placeholder: _vm.placeholder,
        "popper-class": "gwnl-suffix__bg--white",
        clearable: "",
      },
      on: { change: _vm.hangleChanged },
      model: {
        value: _vm.selectedValue,
        callback: function ($$v) {
          _vm.selectedValue = $$v
        },
        expression: "selectedValue",
      },
    },
    _vm._l(_vm.list, function (templateType) {
      return _c("yxt-option", {
        key: templateType.id,
        attrs: { label: templateType.name, value: templateType.id },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }